import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {BackupService} from "../../services/backup.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgIf} from "@angular/common";
import {YesNoPipe} from "../../pipes/yes-no.pipe";

@Component({
    selector: 'app-contact-detail',
    imports: [NgIf, ReactiveFormsModule, YesNoPipe, RouterLink],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-id-card me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Kontakt anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Kontakt bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Kontakt
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <h5 class="mt-2">Zuordnung</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-6">
                            <label>Kategorie</label>
                            <select class="form-control" formControlName="id_contact_category" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                @for (category of categories; track category.id) {
                                    <option [ngValue]="category.id">
                                        {{ category.name }}
                                    </option>
                                }
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                <a [routerLink]="['/contactcategory/', form.value.id_contact_category]">{{ form.value.category }}</a>
                            </p>
                        </div>
                    </div>

                    <h5>Bezeichnung</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col">
                            <label>Bezeichnung</label>
                            <input type="text" class="form-control" formControlName="description" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.description }}</p>
                        </div>
                        <div class="col">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.name }}</p>
                        </div>
                    </div>

                    <h5>Kontaktinformationen</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col">
                            <label>E-Mail</label>
                            <input type="text" class="form-control" formControlName="email" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.email }}
                                @if (form.value.email == null) {
                                    <span class="text-muted">Nicht gesetzt</span>
                                }
                            </p>
                        </div>
                        <div class="col">
                            <label>Telefon</label>
                            <input type="text" class="form-control" formControlName="phone" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.phone }}
                                @if (form.value.phone == null) {
                                    <span class="text-muted">Nicht gesetzt</span>
                                }
                            </p>
                        </div>
                        <div class="col">
                            <label>Webseite</label>
                            <input type="text" class="form-control" formControlName="website" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.website }}
                                @if (form.value.website == null) {
                                    <span class="text-muted">Nicht gesetzt</span>
                                }
                            </p>
                        </div>
                    </div>

                    <h5>Sichtbarkeit</h5>
                    <div class="row g-3 align-items-end">
                        <div class="col">
                            <label>Sichtbar für Franchisenehmer</label>
                            <div *ngIf="viewMode != ViewMode.VIEW">
                                <input type="checkbox" class="form-check-input" formControlName="visible_fn">
                            </div>
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.visible_fn | yesNo }}</p>
                        </div>
                        <div class="col">
                            <label>Sichtbar für Storemitarbeiter</label>
                            <div *ngIf="viewMode != ViewMode.VIEW">
                                <input type="checkbox" class="form-check-input" formControlName="visible_employee">
                            </div>
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.visible_employee | yesNo }}</p>
                        </div>
                    </div>
                </form>

                <div class="mt-3">
                    @if (viewMode == ViewMode.VIEW) {
                        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                        <button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
                    }
                </div>

            </div>
        </div>
    `
})
export class ContactDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private backupService = inject(BackupService);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_contact!: string;
    viewMode!: ViewMode;
    contact: any;

    categories!: any[];

    ngOnInit(): void {
        this.id_contact = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_contact == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            id_contact_category: [null, Validators.required],
            description: [null, Validators.required],
            name: [null, Validators.required],
            email: [null],
            phone: [null],
            website: [null],
            visible_fn: [null],
            visible_employee: [null],

            category: [null],
        });

        if (this.id_contact !== '0') {
            this.getContact();
        }

        this.dataService.request("ContactCategory/listForSelection").subscribe(response => {
            this.categories = response.categories;
        });
    }

    getContact(): void {
        this.dataService.request('Contact/get', {
            id_contact: this.id_contact
        }).subscribe(response => {
            this.contact = response.contact;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.contact.id,
            id_contact_category: this.contact.id_contact_category,
            description: this.contact.description,
            name: this.contact.name,
            email: this.contact.email,
            phone: this.contact.phone,
            website: this.contact.website,
            visible_fn: this.contact.visible_fn == 1,
            visible_employee: this.contact.visible_employee == 1,
            category: this.contact.category,
        });
    }

    save(): void {
        this.dataService.request('Contact/save', {
            contact: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/contact']);
            this.toastrService.success('Der Kontakt wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Contact/update', {
            contact: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getContact();
            this.toastrService.success('Der Kontakt wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/contact']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getContact();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Kontakt wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Contact/delete', {
                    id_contact: this.id_contact
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Der Kontakt wurde gelöscht');
                });
            }
        });
    }

}
